<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/banner.jpg"
    ></landingBanner>
    <div class="industry-form">
      <div class="form-insite">
        <indexTitle title1="填写联系电话了解课程详情" title2="To get the tuition" color="rgb(162, 16, 29)"></indexTitle>
        <footerForm color="#fff" bag="rgb(162, 16, 29)" words="点击获取"></footerForm>
      </div>
    </div>
    <div class="content">
      <div style="width:100%;height:20px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part1.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <div class="part2">
      <h2 style="color:rgb(162, 16, 29);text-align:center;">2020年时尚高薪的四大职业</h2>
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part2-1.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find goto="baking9" color1="rgb(162, 16, 29)" color2="rgb(162, 16, 29)"></find>
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part2-2.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find goto="westfood9" color1="rgb(162, 16, 29)" color2="rgb(162, 16, 29)"></find>
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part2-3.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find goto="coffee" color1="rgb(162, 16, 29)" color2="rgb(162, 16, 29)"></find>
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part2-4.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find goto="wine" color1="rgb(162, 16, 29)" color2="rgb(162, 16, 29)"></find>
    </div>
    <div class="content">
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part3.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="rgb(162, 16, 29)" style="width:100%" to="chat">了解更多</van-button>
      </div>
    </div>
    <div class="part4">
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part4.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <div class="content">
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part5.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="rgb(162, 16, 29)" style="width:100%" to="chat">更多优秀案例</van-button>
      </div>
    </div>
    <div class="part6">
      <div style="width:100%;height:15px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part6.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <div class="content">
      <div class="button">
        <van-button color="rgb(162, 16, 29)" style="width:100%" to="chat">了解更多详情</van-button>
      </div>
      <div style="width:100%;height:30px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/part7.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle title1="填写联系电话了解课程详情" title2="To get the tuition" color="rgb(162, 16, 29)"></indexTitle>
      <footerForm color="#fff" bag="rgb(162, 16, 29)" words="点击获取"></footerForm>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm"),
    find: () => import("@/components/common/find")
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.industry-form {
  width: 100%;
  background: rgb(162, 16, 29);
  padding: 17px;
  margin-top: -6px;
}
.form-insite {
  border-radius: 10px;
  background: #fff;
}
.content {
  width: 100%;
  padding: 10px;
  background: #fff;
}
.part2 {
  width: 100%;
  padding: 70px 30px 25px 30px;
  background-repeat: no-repeat;
  background-image: url(https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/back.jpg);
  background-size: 100% 101%;
}
.button {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
</style>